export function getReplaceStateUrl({
  href,
  pathname,
}: {
  href: string;
  pathname: string;
}): string | undefined {
  // check for root path URLs which contain # as these break single-spa-layout
  // currently these are mainly caused by Facebook and Google social redirects
  // which can land users on /# or /#_=_

  // See "Change in Session Redirect Behavior" in the following link:
  // https://developers.facebook.com/blog/post/552/

  if (pathname !== '/' || !href.includes('#')) {
    return undefined;
  }

  // put params to one side to be handled later
  let [url, params] = href.split(/(\?.+)+/);

  // find any hash (# or #<hash>)
  const hash = url.split(/(#.*)+/)[1];

  if (hash) {
    // strip # or #<hash>
    url = url.replace(hash, '');
  }

  if (params) {
    // strip any remaining # characters in params
    params = params.replace(/#/g, '');
  }

  // return hash stripped url with preserved hash stripped params
  return `${url}${params || ''}`;
}
